<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <showtimes-calendar :column="column" :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" :productSelector="true" :resourceSelector="true" :initialWeekStart="initialWeekStart" />
  </div>
</template>

<script>

import components from '~/lib/components'
import ShowtimesCalendar from '~/components/ShowtimesCalendar'

export default {
  mixins: [components],
  components: {
    ShowtimesCalendar
  },
  computed: {
    weekMode () {
      if (this.component && this.component.data) {
        try {
          const data = JSON.parse(this.component.data)
          if (data.weekMode) {
            return data.weekMode
          }
        } catch (e) {}
      }
      return 'mon-sun'
    },
    initialWeekStart () {
      return this.weekMode === 'fri-thu' ? 5 : 1
    }
  }
}

</script>
